// You can use CONSTANTS.js file for below definitions of constants and import here.
import callApi from "../../Api";
import { push } from "react-router-redux";
import { ToastMessage, SUCCESS, ERROR } from "../../common/ToastMessage";
import {
  ONLINE,
  PAYMENT_DUE,
  PAYMENT_FOR_DRESS,
  ADMISSION_FORWARD,
  CASH,
  CHEQUE,
} from "../../components/constants";
import { saveAs } from "file-saver";
import moment from "moment";
export const PAY_NOW = "PAY_NOW";
export const OPEN_LOADER = "OPEN_LOADER";
export const CLOSE_LOADER = "CLOSE_LOADER";
export const PYAMENT_STATUS_DETAILS = "PAYMENT_STATUS_DETAILS";
export const PAYMENTS_DATA = "PAYMENTS_DATA";
export const RESET_PAYMENTS_DATA = "RESET_PAYMENTS_DATA";

function isDate(val) {
  // Cross realm comptatible
  return Object.prototype.toString.call(val) === "[object Date]";
}

function isObj(val) {
  return typeof val === "object";
}

export const stringifyValue = (val) => {
  if (isObj(val) && !isDate(val)) {
    return JSON.stringify(val);
  } else {
    return val;
  }
};

const buildForm = ({ action, target, params }) => {
  const form = document.createElement("form");
  form.setAttribute("method", "post");
  form.setAttribute("action", action);
  form.setAttribute("target", target);

  Object.keys(params).forEach((key) => {
    const input = document.createElement("input");
    input.setAttribute("type", "hidden");
    input.setAttribute("name", key);
    input.setAttribute("value", stringifyValue(params[key]));
    form.appendChild(input);
  });

  return form;
};

export const post = (details) => {
  const form = buildForm(details);
  document.body.appendChild(form);
  form.submit();
  form.remove();
};

export const openLoader = (data) => ({
  type: OPEN_LOADER,
  payload: true,
});
export const closeLoader = (data) => ({
  type: CLOSE_LOADER,
  payload: false,
});

export const payNowAction = (user) => ({
  type: PAY_NOW,
  payload: user,
});

// export const payNow = (payload) => async (dispatch) => {
//   try {
//     dispatch(openLoader());
//     let data;
//     if (payload.payFrom === PAYMENT_DUE) {
//       data = await callApi.post("/payments/payDue", payload);
//     } else if (payload.payFrom === PAYMENT_FOR_DRESS) {
//       data = await callApi.post("/payments/payForDress", payload);
//     } else if (payload.payFrom === ADMISSION_FORWARD) {
//       data = await callApi.post("payments/payAdmissionForwardFee", payload);
//     } else {
//       data = await callApi.post("/payments/payAdmissionFee", payload);
//     }
//     if (data.data.success) {
//       if (payload.payMode === ONLINE) {
//         const requestedParams = {
//           // action: "https://securegw-stage.paytm.in/theia/processTransaction",
//           action: data.data.data.transactionUrl,
//           params: data.data.data,
//           target: "_self",
//         };
//         post(requestedParams);
//       } else {
//         ToastMessage(SUCCESS, data.data.message);
//         dispatch(push(`/payment/status/${data.data.data.ORDER_ID}`));
//       }
//       dispatch(closeLoader());
//       //   dispatch(payNowAction(userObj));
//     } else {
//       ToastMessage(ERROR, data.data.message);
//       dispatch(closeLoader());
//     }
//   } catch (error) {
//     console.log("Error message", error);
//     ToastMessage(ERROR, error);
//     dispatch(closeLoader());
//   }
// };
export const payNow = (payload) => async (dispatch) => {
  try {
    dispatch(openLoader());
    let data;
    if (payload.payFrom === PAYMENT_DUE) {
      data = await callApi.post("/payments/payDue", payload);
    } else if (payload.payFrom === PAYMENT_FOR_DRESS) {
      data = await callApi.post("/payments/payForDress", payload);
    } else if (payload.payFrom === ADMISSION_FORWARD) {
      data = await callApi.post("payments/payAdmissionForwardFee", payload);
    } else {
      data = await callApi.post("/payments/payAdmissionFee", payload);
    }
    if (data.data.success) {
      if (payload.payMode === ONLINE) {
        const requestedParams = {
          // action: "https://securegw-stage.paytm.in/theia/processTransaction",
          action: data.data.data?.transactionUrl,
          params: data.data.data,
          target: "_self",
        };
        ToastMessage(SUCCESS, data.data.message);
        post(requestedParams);
      } else {
        ToastMessage(SUCCESS, data.data.message);
        dispatch(push(`/payment/status/${data.data.data.ORDER_ID}`));
      }
      dispatch(closeLoader());
      //   dispatch(payNowAction(userObj));
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message", error);
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const paymentStatusAction = (payload) => async (dispatch) => {
  try {
    dispatch(openLoader());
    let data;
    data = await callApi.get("/payments/status", { params: payload });
    if (data.data.success) {
      const paymentData = data.data.data;
      // paymentData.paidOn = new Date(paymentData.createdAt)
      dispatch({
        type: PYAMENT_STATUS_DETAILS,
        payload: paymentData,
      });
      dispatch(closeLoader());
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
      dispatch(push("/dashboard"));
    }
  } catch (error) {
    console.log("Error message", error);
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const downloadInvoice = (payload) => async (dispatch) => {
  // dispatch(openLoader());
  // await  window.open(`${process.env.REACT_APP_API_ENDPOINT}payments/downloadInvoice?OrderId=${payload.OrderId}`,'_self')
  // dispatch(closeLoader());
  try {
    dispatch(openLoader());
    const data = await callApi.get("payments/downloadInvoice", {
      params: payload,
    });
    if (data.data.success) {
      dispatch(closeLoader());
      console.log(data.data.data);
      // window.open(data.data.data, '_blank');
      saveAs(data.data.data.url, data.data.data.name);
      ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message", error);
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const paymentDetailsFormatter = (obj)=>{
  let paymentInfo = {
    ORDER_ID: obj.ORDER_ID,
    payMode: obj.payMode,
    createdAt: obj.createdAt,
    CurrencyNote: obj.CurrencyNote,
    ChequeTransaction: obj.ChequeTransaction,
    OnlineTransaction: obj.OnlineTransaction,
    tableData: [],
    tableHeaders: [],
    nestedHeaders: [],
  };
  switch (obj.payMode) {
    case CASH:
      const { twoThousand, fiveHundred, twoHundred, hundred } =
        obj.CurrencyNote;
      paymentInfo.tableData = [
        {
          twoThousand,
          fiveHundred,
          twoHundred,
          hundred,
          ORDER_ID: obj.ORDER_ID,
          createdAt: obj.createdAt,
          payMode: obj.payMode,
          clearedDate: '-'
        },
      ];
      paymentInfo.tableHeaders = [
        {
          headerName: "Payment Mode",
          field: "payMode",
          maxWidth:150,
        },
        // { name: "Transaction Id", key: "ORDER_ID" },
        // {
        //   headerName: "Currency",
        //   key: "Currency",
        //   children: [
            {
              headerName: "Two Thousand Notes",
              field: "twoThousand",
              maxWidth:200,
            },
            {
              headerName: "Five Hundred Notes",
              field: "fiveHundred",
              maxWidth:200,
            },
            {
              headerName: "Two Hundred Notes",
              field: "twoHundred",
              maxWidth:170,
            },
            {
              headerName: "Hundred Notes",
              field: "hundred",
              maxWidth:150,
            },
        //   ],
        // },
        { headerName: "Paid On", field: "createdAt" },
      ];
      paymentInfo.nestedHeaders = [
        "",
        "2000",
        "500",
        "200",
        "100",
        "",
      ];
      break;
    case CHEQUE:
      const {
        chequeNumber,
        chequeExpiryDate,
        chequeIssueDate,
        nameOfBank,
        accountHolderName,
        accountNumber,
        clearedDate,
        status,
        reason
      } = obj.ChequeTransaction;
      paymentInfo.tableData = [
        {
          chequeNumber,
          chequeExpiryDate: moment(chequeExpiryDate).format("YYYY-MM-DD"),
          chequeIssueDate: moment(chequeIssueDate).format("YYYY-MM-DD"),
          nameOfBank,
          accountHolderName,
          accountNumber,
          clearedDate: moment(clearedDate).format("YYYY-MM-DD"),
          ORDER_ID: obj.ORDER_ID,
          createdAt: obj.createdAt,
          payMode: obj.payMode,
          status,
          reason
        },
      ];
      paymentInfo.isClearedCheque = clearedDate ? true : false;
      paymentInfo.tableHeaders = [
        {
          headerName: "Payment Mode",
          field: "payMode",
          maxWidth:150
        },
       
        // {
        //   headerName: "Cheque",
        //   key: "Cheque",
        //   children: [
            {
              headerName: "Cheque Number",
              field: "chequeNumber",
            },
            {
              headerName: "Issue Date",
              field: "chequeIssueDate",
              maxWidth:150
            },
            {
              headerName: "Expiry Date",
              field: "chequeExpiryDate",
              maxWidth:150
            },
            {
              headerName: "Name Of Bank",
              field: "nameOfBank",
            },
            {
              headerName: "Account Holder Name",
              field: "accountHolderName",
            },
            {
              headerName: "Account Number",
              field: "accountNumber",
            },
            {
              headerName: "Resolved Date",
              field: "clearedDate",
              maxWidth:150
        },
        {
          headerName: "Status",
          field: "status",
          maxWidth:150
        },
        {
          headerName: "Reason",
          field: "reason",
        },
          // ],
        // },
        { headerName: "Created On", field: "createdAt" },
      ];
      paymentInfo.nestedHeaders = [
        "",
        "",
        "",
        "",
        "Number",
        "Issue",
        "Expiry",
        "Bank",
        "Account Holder Name",
        "Account Number",
        "",
      ];
      break;

    case ONLINE:
      
      if(obj.OnlineTransaction){
        const {
          TXNID,
          TXNAMOUNT,
          PAYMENTMODE,
          TXNDATE,
          STATUS,
          RESPCODE,
          RESPMSG,
          GATEWAYNAME,
          BANKTXNID,
          BANKNAME,
        } = obj.OnlineTransaction;

      paymentInfo.tableData = [
        {
            TXNID,
            TXNAMOUNT,
            PAYMENTMODE,
            TXNDATE: moment(TXNDATE).format("YYYY-MM-DD HH:MM:SS a"),
            STATUS,
            RESPCODE,
            RESPMSG,
            GATEWAYNAME,
            BANKTXNID,
            BANKNAME,
          ORDER_ID: obj.ORDER_ID,
          createdAt: obj.createdAt,
          payMode: obj.payMode,
        },
      ];
      paymentInfo.tableHeaders = [
        {
          headerName: "Payment Mode",
          field: "payMode",
          maxWidth:150
        },
        // { headerName: "Transaction Id", key: "ORDER_ID" },
        // {
        //   headerName: "Online",
        //   field: "Online",
        //   children: [
            {
              headerName: "Transaction Id",
              field: "TXNID",
            },
            {
              headerName: "Mode",
              field: "PAYMENTMODE",
              maxWidth:100
            },
            {
              headerName: "Transaction Date",
              field: "TXNDATE",
            },
            {
              headerName: "Status",
              field: "STATUS",
              maxWidth:150
            },
            // {
            //   headerName: "Gateway Name",
            //   field: "GATEWAYNAME",
            // },
            {
              headerName: "Bank Transaction Id",
              field: "BANKTXNID",
            },
            {
              headerName: "Bank Name",
              field: "BANKNAME",
            },
        //   ],
        // },
        // { name: "Paid On", key: "createdAt" },
      ];
      paymentInfo.nestedHeaders = ["",'Transaction Id', 'Mode', 'Transaction Date', 'Status', 'Bank Transaction Id', 'Bank'];
      }
      
      break;

    default:
      break;
  }
  return paymentInfo;
}
export const formatPaymentList  = (data)=>{
  const paymentData = data.filter((obj) => {
    obj.name = obj?.Student?.User?.firstName + " " + obj?.Student?.User?.lastName;
    obj.phoneNumber = obj.Student?.User?.phoneNumber;
    obj.transactionStatus = obj?.PaymentStatus.status;
    obj.payMode = obj?.PaymentMode.name;
    obj.RegNo = obj.Student?.RegNo;
    obj.createdAt = moment(obj.createdAt).format("YYYY-MM-DD HH:MM:SS a");
    obj.paymentInfo = paymentDetailsFormatter(obj);
    return obj;
  });
  return paymentData;
}
export const paymentsListAction = (payload) => async (dispatch) => {
  try {
    dispatch(openLoader());
    let data;
    data = await callApi.get("/payments/list",{params: payload});
    if (data.data.success) {
      const paymentData = formatPaymentList(data.data.data.rows);
      console.log(paymentData)
      dispatch({
        type: PAYMENTS_DATA,
        payload: {
          paymentData,
          totalItems: data.data.data.totalItems,
          totalPages: data.data.data.totalPages,
          currentPage: data.data.data.currentPage
        },
      });
      dispatch(closeLoader());
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
      dispatch(push("/dashboard"));
    }
  } catch (error) {
    console.log("Error message", error);
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const resetPaymentDataAction = (payload) => async (dispatch) => {
  dispatch({
    type: RESET_PAYMENTS_DATA,
    payload: [],
  });
};

export const downloadPaymentReportAction = (payload) => async (dispatch) => {
 
  try {
    dispatch(openLoader());
    const data = await callApi.get("payments/downloadPaymentReports",{params: payload});
    if (data.data.success) {
      dispatch(closeLoader());
      console.log(data.data.data)
      saveAs(data.data.data.url, data.data.data.name);
      // window.open(data.data.data, '_self');
      ToastMessage(SUCCESS, data.data.message);
      } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};
export const downloadPaymentDueReportAction = (payload) => async (dispatch) => {
 
  try {
    dispatch(openLoader());
    const data = await callApi.get("student/downloadPaymentDueReports",{params: payload});
    if (data.data.success) {
      dispatch(closeLoader());
      console.log(data.data.data)
      saveAs(data.data.data.url, data.data.data.name);
      // window.open(data.data.data, '_self');
      ToastMessage(SUCCESS, data.data.message);
      } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};